"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/*
query ArtworkFilterQuery(
  $acquireable: Boolean
  $aggregations: [ArtworkAggregation] = [TOTAL]
  $artist_id: String
  $at_auction: Boolean
  $attribution_class: [String]
  $color: String
  $for_sale: Boolean
  $height: String
  $inquireable_only: Boolean
  $major_periods: [String]
  $medium: String
  $offerable: Boolean
  $page: Int
  $partner_id: ID
  $price_range: String
  $sort: String
  $keyword: String
  $width: String
) {
  viewer {
    ...ArtworkFilter_viewer_gWlR2
  }
}

fragment ArtworkFilter_viewer_gWlR2 on Viewer {
  filtered_artworks: filter_artworks(acquireable: $acquireable, aggregations: $aggregations, artist_id: $artist_id, at_auction: $at_auction, attribution_class: $attribution_class, color: $color, for_sale: $for_sale, height: $height, inquireable_only: $inquireable_only, keyword: $keyword, major_periods: $major_periods, medium: $medium, offerable: $offerable, page: $page, partner_id: $partner_id, price_range: $price_range, size: 0, sort: $sort, width: $width) {
    __id
    ...ArtworkFilterArtworkGrid2_filtered_artworks
  }
}

fragment ArtworkFilterArtworkGrid2_filtered_artworks on FilterArtworks {
  __id
  aggregations {
    slice
    counts {
      id
      name
      count
      __id
    }
  }
  artworks: artworks_connection(first: 30, after: "") {
    pageInfo {
      hasNextPage
      endCursor
    }
    pageCursors {
      ...Pagination_pageCursors
    }
    edges {
      node {
        __id
      }
    }
    ...ArtworkGrid_artworks
  }
}

fragment Pagination_pageCursors on PageCursors {
  around {
    cursor
    page
    isCurrent
  }
  first {
    cursor
    page
    isCurrent
  }
  last {
    cursor
    page
    isCurrent
  }
  previous {
    cursor
    page
  }
}

fragment ArtworkGrid_artworks on ArtworkConnection {
  edges {
    node {
      __id
      id
      href
      image {
        aspect_ratio
        __id: id
      }
      ...GridItem_artwork
    }
  }
}

fragment GridItem_artwork on Artwork {
  _id
  title
  image_title
  image {
    placeholder
    url(version: "large")
    aspect_ratio
    __id: id
  }
  href
  ...Metadata_artwork
  ...Save_artwork
  ...Badge_artwork
  __id
}

fragment Metadata_artwork on Artwork {
  ...Details_artwork
  ...Contact_artwork
  href
  __id
}

fragment Save_artwork on Artwork {
  __id
  _id
  id
  is_saved
  title
}

fragment Badge_artwork on Artwork {
  is_biddable
  is_acquireable
  is_offerable
  href
  sale {
    is_preview
    display_timely_at
    __id
  }
  __id
}

fragment Details_artwork on Artwork {
  href
  title
  date
  sale_message
  cultural_maker
  artists(shallow: true) {
    __id
    href
    name
  }
  collecting_institution
  partner(shallow: true) {
    name
    href
    __id
  }
  sale {
    is_auction
    is_closed
    __id
  }
  sale_artwork {
    counts {
      bidder_positions
    }
    highest_bid {
      display
      __id: id
    }
    opening_bid {
      display
    }
    __id
  }
  __id
}

fragment Contact_artwork on Artwork {
  href
  is_inquireable
  sale {
    is_auction
    is_live_open
    is_open
    is_closed
    __id
  }
  partner(shallow: true) {
    type
    __id
  }
  sale_artwork {
    highest_bid {
      display
      __id: id
    }
    opening_bid {
      display
    }
    counts {
      bidder_positions
    }
    __id
  }
  __id
}
*/
var node = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "acquireable",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "aggregations",
    "type": "[ArtworkAggregation]",
    "defaultValue": ["TOTAL"]
  }, {
    "kind": "LocalArgument",
    "name": "artist_id",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "at_auction",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "attribution_class",
    "type": "[String]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "color",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "for_sale",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "height",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "inquireable_only",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "major_periods",
    "type": "[String]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "medium",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "offerable",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "partner_id",
    "type": "ID",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "price_range",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "keyword",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "width",
    "type": "String",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "page",
    "args": null,
    "storageKey": null
  },
      v6 = [v4, v5, {
    "kind": "ScalarField",
    "alias": null,
    "name": "isCurrent",
    "args": null,
    "storageKey": null
  }],
      v7 = [{
    "kind": "Literal",
    "name": "shallow",
    "value": true,
    "type": "Boolean"
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "href",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": "__id",
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "display",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ArtworkFilterQuery",
    "id": null,
    "text": "query ArtworkFilterQuery(\n  $acquireable: Boolean\n  $aggregations: [ArtworkAggregation] = [TOTAL]\n  $artist_id: String\n  $at_auction: Boolean\n  $attribution_class: [String]\n  $color: String\n  $for_sale: Boolean\n  $height: String\n  $inquireable_only: Boolean\n  $major_periods: [String]\n  $medium: String\n  $offerable: Boolean\n  $page: Int\n  $partner_id: ID\n  $price_range: String\n  $sort: String\n  $keyword: String\n  $width: String\n) {\n  viewer {\n    ...ArtworkFilter_viewer_gWlR2\n  }\n}\n\nfragment ArtworkFilter_viewer_gWlR2 on Viewer {\n  filtered_artworks: filter_artworks(acquireable: $acquireable, aggregations: $aggregations, artist_id: $artist_id, at_auction: $at_auction, attribution_class: $attribution_class, color: $color, for_sale: $for_sale, height: $height, inquireable_only: $inquireable_only, keyword: $keyword, major_periods: $major_periods, medium: $medium, offerable: $offerable, page: $page, partner_id: $partner_id, price_range: $price_range, size: 0, sort: $sort, width: $width) {\n    __id\n    ...ArtworkFilterArtworkGrid2_filtered_artworks\n  }\n}\n\nfragment ArtworkFilterArtworkGrid2_filtered_artworks on FilterArtworks {\n  __id\n  aggregations {\n    slice\n    counts {\n      id\n      name\n      count\n      __id\n    }\n  }\n  artworks: artworks_connection(first: 30, after: \"\") {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    pageCursors {\n      ...Pagination_pageCursors\n    }\n    edges {\n      node {\n        __id\n      }\n    }\n    ...ArtworkGrid_artworks\n  }\n}\n\nfragment Pagination_pageCursors on PageCursors {\n  around {\n    cursor\n    page\n    isCurrent\n  }\n  first {\n    cursor\n    page\n    isCurrent\n  }\n  last {\n    cursor\n    page\n    isCurrent\n  }\n  previous {\n    cursor\n    page\n  }\n}\n\nfragment ArtworkGrid_artworks on ArtworkConnection {\n  edges {\n    node {\n      __id\n      id\n      href\n      image {\n        aspect_ratio\n        __id: id\n      }\n      ...GridItem_artwork\n    }\n  }\n}\n\nfragment GridItem_artwork on Artwork {\n  _id\n  title\n  image_title\n  image {\n    placeholder\n    url(version: \"large\")\n    aspect_ratio\n    __id: id\n  }\n  href\n  ...Metadata_artwork\n  ...Save_artwork\n  ...Badge_artwork\n  __id\n}\n\nfragment Metadata_artwork on Artwork {\n  ...Details_artwork\n  ...Contact_artwork\n  href\n  __id\n}\n\nfragment Save_artwork on Artwork {\n  __id\n  _id\n  id\n  is_saved\n  title\n}\n\nfragment Badge_artwork on Artwork {\n  is_biddable\n  is_acquireable\n  is_offerable\n  href\n  sale {\n    is_preview\n    display_timely_at\n    __id\n  }\n  __id\n}\n\nfragment Details_artwork on Artwork {\n  href\n  title\n  date\n  sale_message\n  cultural_maker\n  artists(shallow: true) {\n    __id\n    href\n    name\n  }\n  collecting_institution\n  partner(shallow: true) {\n    name\n    href\n    __id\n  }\n  sale {\n    is_auction\n    is_closed\n    __id\n  }\n  sale_artwork {\n    counts {\n      bidder_positions\n    }\n    highest_bid {\n      display\n      __id: id\n    }\n    opening_bid {\n      display\n    }\n    __id\n  }\n  __id\n}\n\nfragment Contact_artwork on Artwork {\n  href\n  is_inquireable\n  sale {\n    is_auction\n    is_live_open\n    is_open\n    is_closed\n    __id\n  }\n  partner(shallow: true) {\n    type\n    __id\n  }\n  sale_artwork {\n    highest_bid {\n      display\n      __id: id\n    }\n    opening_bid {\n      display\n    }\n    counts {\n      bidder_positions\n    }\n    __id\n  }\n  __id\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ArtworkFilterQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": "viewer",
        "name": "__viewer_viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ArtworkFilter_viewer",
          "args": [{
            "kind": "Variable",
            "name": "acquireable",
            "variableName": "acquireable",
            "type": null
          }, {
            "kind": "Variable",
            "name": "aggregations",
            "variableName": "aggregations",
            "type": null
          }, {
            "kind": "Variable",
            "name": "artist_id",
            "variableName": "artist_id",
            "type": null
          }, {
            "kind": "Variable",
            "name": "at_auction",
            "variableName": "at_auction",
            "type": null
          }, {
            "kind": "Variable",
            "name": "attribution_class",
            "variableName": "attribution_class",
            "type": null
          }, {
            "kind": "Variable",
            "name": "color",
            "variableName": "color",
            "type": null
          }, {
            "kind": "Variable",
            "name": "for_sale",
            "variableName": "for_sale",
            "type": null
          }, {
            "kind": "Variable",
            "name": "height",
            "variableName": "height",
            "type": null
          }, {
            "kind": "Variable",
            "name": "inquireable_only",
            "variableName": "inquireable_only",
            "type": null
          }, {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "keyword",
            "type": null
          }, {
            "kind": "Variable",
            "name": "major_periods",
            "variableName": "major_periods",
            "type": null
          }, {
            "kind": "Variable",
            "name": "medium",
            "variableName": "medium",
            "type": null
          }, {
            "kind": "Variable",
            "name": "offerable",
            "variableName": "offerable",
            "type": null
          }, {
            "kind": "Variable",
            "name": "page",
            "variableName": "page",
            "type": null
          }, {
            "kind": "Variable",
            "name": "partner_id",
            "variableName": "partner_id",
            "type": null
          }, {
            "kind": "Variable",
            "name": "price_range",
            "variableName": "price_range",
            "type": null
          }, {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort",
            "type": null
          }, {
            "kind": "Variable",
            "name": "width",
            "variableName": "width",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ArtworkFilterQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": "filtered_artworks",
          "name": "filter_artworks",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "acquireable",
            "variableName": "acquireable",
            "type": "Boolean"
          }, {
            "kind": "Variable",
            "name": "aggregations",
            "variableName": "aggregations",
            "type": "[ArtworkAggregation]"
          }, {
            "kind": "Variable",
            "name": "artist_id",
            "variableName": "artist_id",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "at_auction",
            "variableName": "at_auction",
            "type": "Boolean"
          }, {
            "kind": "Variable",
            "name": "attribution_class",
            "variableName": "attribution_class",
            "type": "[String]"
          }, {
            "kind": "Variable",
            "name": "color",
            "variableName": "color",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "for_sale",
            "variableName": "for_sale",
            "type": "Boolean"
          }, {
            "kind": "Variable",
            "name": "height",
            "variableName": "height",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "inquireable_only",
            "variableName": "inquireable_only",
            "type": "Boolean"
          }, {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "keyword",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "major_periods",
            "variableName": "major_periods",
            "type": "[String]"
          }, {
            "kind": "Variable",
            "name": "medium",
            "variableName": "medium",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "offerable",
            "variableName": "offerable",
            "type": "Boolean"
          }, {
            "kind": "Variable",
            "name": "page",
            "variableName": "page",
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "partner_id",
            "variableName": "partner_id",
            "type": "ID"
          }, {
            "kind": "Variable",
            "name": "price_range",
            "variableName": "price_range",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "size",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "width",
            "variableName": "width",
            "type": "String"
          }],
          "concreteType": "FilterArtworks",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "aggregations",
            "storageKey": null,
            "args": null,
            "concreteType": "ArtworksAggregationResults",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "slice",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "counts",
              "storageKey": null,
              "args": null,
              "concreteType": "AggregationCount",
              "plural": true,
              "selections": [v2, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }, v1]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "artworks",
            "name": "artworks_connection",
            "storageKey": "artworks_connection(after:\"\",first:30)",
            "args": [{
              "kind": "Literal",
              "name": "after",
              "value": "",
              "type": "String"
            }, {
              "kind": "Literal",
              "name": "first",
              "value": 30,
              "type": "Int"
            }],
            "concreteType": "ArtworkConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageCursors",
              "storageKey": null,
              "args": null,
              "concreteType": "PageCursors",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "around",
                "storageKey": null,
                "args": null,
                "concreteType": "PageCursor",
                "plural": true,
                "selections": v6
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "first",
                "storageKey": null,
                "args": null,
                "concreteType": "PageCursor",
                "plural": false,
                "selections": v6
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "last",
                "storageKey": null,
                "args": null,
                "concreteType": "PageCursor",
                "plural": false,
                "selections": v6
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "previous",
                "storageKey": null,
                "args": null,
                "concreteType": "PageCursor",
                "plural": false,
                "selections": [v4, v5]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ArtworkEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Artwork",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "artists",
                  "storageKey": "artists(shallow:true)",
                  "args": v7,
                  "concreteType": "Artist",
                  "plural": true,
                  "selections": [v1, v8, v3]
                }, v1, v8, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "image",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Image",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "aspect_ratio",
                    "args": null,
                    "storageKey": null
                  }, v9, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "placeholder",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": [{
                      "kind": "Literal",
                      "name": "version",
                      "value": "large",
                      "type": "[String]"
                    }],
                    "storageKey": "url(version:\"large\")"
                  }]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "_id",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "image_title",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "date",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "sale_message",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cultural_maker",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "collecting_institution",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "partner",
                  "storageKey": "partner(shallow:true)",
                  "args": v7,
                  "concreteType": "Partner",
                  "plural": false,
                  "selections": [v3, v8, v1, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "sale",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Sale",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_auction",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_closed",
                    "args": null,
                    "storageKey": null
                  }, v1, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_live_open",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_open",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "is_preview",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "display_timely_at",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "sale_artwork",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SaleArtwork",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "counts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SaleArtworkCounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "bidder_positions",
                      "args": null,
                      "storageKey": null
                    }]
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "highest_bid",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SaleArtworkHighestBid",
                    "plural": false,
                    "selections": [v10, v9]
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "opening_bid",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SaleArtworkOpeningBid",
                    "plural": false,
                    "selections": [v10]
                  }, v1]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_inquireable",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_saved",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_biddable",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_acquireable",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "is_offerable",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "viewer",
        "args": null,
        "handle": "viewer",
        "key": "",
        "filters": null
      }]
    }
  };
}();

node.hash = 'a06aa27bf817129fa27fb93d0b8d9ffa';
var _default = node;
exports.default = _default;
//# sourceMappingURL=ArtworkFilterQuery.graphql.js.map